// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".historical-conversation[data-v-01249556]{height:calc(100vh - 175px);border:1px solid #ccc}.historical-conversation .iframe[data-v-01249556]{width:100%;height:100%;border:0}[data-v-01249556] .right-view{width:50%}[data-v-01249556] .left-wrap{overflow-y:auto}", ""]);
// Exports
module.exports = exports;
